var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightgreenGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4264 8.3259C26.7872 9.10529 24.2654 10.2379 21.9296 11.6929L15.3727 7.84049L6.76633 16.9323L11.0194 23.2503C9.70738 25.6763 8.72777 28.2679 8.10697 30.9552L0.679443 32.8968L1.04929 45.4943L8.52304 46.9582C9.30908 49.5926 10.4413 52.111 11.8901 54.4474L8.03763 61.0043L17.2065 69.6183L23.5168 65.3652C25.9443 66.6758 28.5353 67.6578 31.2217 68.2854L33.1479 75.7206L45.7454 75.3431L47.2016 67.8693C49.8397 67.0867 52.361 65.9543 54.6985 64.5023L61.2553 68.3547L69.9002 59.1859L65.6471 52.8679C66.9583 50.4415 67.9379 47.85 68.5596 45.163L75.9332 43.2599L75.5633 30.6701L68.0896 29.2062C67.3021 26.5699 66.1699 24.0492 64.7225 21.7093L68.575 15.1524L59.4062 6.51524L53.0882 10.7606C50.6617 9.44944 48.0703 8.46988 45.3833 7.84819L43.4802 0.474609L30.8826 0.852142L29.4264 8.3259ZM38.4334 54.4089C47.3696 54.4089 54.6137 47.1647 54.6137 38.2286C54.6137 29.2925 47.3696 22.0483 38.4334 22.0483C29.4973 22.0483 22.2532 29.2925 22.2532 38.2286C22.2532 47.1647 29.4973 54.4089 38.4334 54.4089Z",
    fill: "#94CEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightgreenGear);
export default __webpack_public_path__ + "static/media/lightgreen-gear.80fe4e634bafe3c61744434a7a1514ef.svg";
export { ForwardRef as ReactComponent };